import React from 'react';
import PropTypes from "prop-types";
import makeStyles from '@mui/styles/makeStyles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: 10,
  },
  heading: {
    fontSize: '1rem',
    flexBasis: '33.33%',
    flexShrink: 0,
    fontWeight: 700,
    display: 'contents'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const ControlledExpansionPanels = props => {
  const classes = useStyles();
  const { isExpanded, title, instructions, summary, isDisabledExpand, disabled, hideExpandIcon } = props;
  const [expanded, setExpanded] = React.useState(isExpanded);

  const handleChange = (event, isExpanded) => {
    if(!isDisabledExpand) setExpanded(isExpanded);
  };

  return (
    <div className={classes.root}>
      <Accordion disabled={disabled} expanded={expanded} onChange={handleChange}>
        <AccordionSummary
          expandIcon={!hideExpandIcon && <ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>{title}</Typography>
          <Typography className={classes.secondaryHeading}>{instructions}</Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: 'inherit'}}>
          <Typography>
            {summary}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

ControlledExpansionPanels.propTypes = {
  isExpanded: PropTypes.bool,
  summary: PropTypes.string,
  title: PropTypes.string,
  instructions: PropTypes.string,
  isDisabledExpand: PropTypes.bool,
  hideExpandIcon: PropTypes.bool,
  disabled: PropTypes.bool
};

ControlledExpansionPanels.defaultProps = {
  isExpanded: false,
  summary: "",
  title: "",
  instructions: "",
  isDisabledExpand: false,
  hideExpandIcon: false,
  disabled: false
};

export default ControlledExpansionPanels;